var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"download-link",class:_vm.getColor,attrs:{"href":_vm.href,"target":"_blank"}},[_c('div',{staticClass:"download-link__inner"},[(_vm.iconBefore)?_c('div',{staticClass:"download-link__icon"},[_c('img',{attrs:{"src":_vm.iconBefore}})]):_vm._e(),_c('div',{staticClass:"download-link__text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }